'use strict';

function PerformanceReviewQuestionnaireController(performanceReviewService, errorHandlerService, $location, $interpolate, $modal, $rootScope) {
  var vm = this;

  vm.$onInit = $onInit;
  vm.$onDestroy = $onDestroy;
  vm.stepChange = stepChange;

  vm.stepChangeOk = stepChangeOk;
  vm.stepChangeFailed = stepChangeFailed;
  vm.showBusinessGoals = showBusinessGoals;
  vm.hasBusinessGoals = hasBusinessGoals;
  vm.hasRole = hasRole;
  vm.updateCurrentAnswer = updateCurrentAnswer;

  function $onInit() {
    vm.max = vm.data.max;
    vm.current = vm.data.current || 0;
    vm.answers = vm.data.answers || [];
    vm.question = vm.data.question;
    vm.choices = vm.data.question.choices;
    vm.round = vm.data.round;

    vm.choice = vm.data.question.answer.choice;
    vm.reflection = vm.data.question.answer.reflection;
    vm.when = vm.data.question.answer.when;
    vm.what = vm.data.question.answer.what;
    vm.how = vm.data.question.answer.how;
    vm.user = vm.data.user || {};

    if (vm.data.previous_answer.state === 'COMPLETE') {
      vm.previous = vm.data.previous_answer;
    }
    if (vm.data.user.id !== vm.me.id) {
      $rootScope.$broadcast('$setManagerSCope', true);
    } else {
      $rootScope.$broadcast('$setManagerSCope', false);
    }

    vm.didStepChange = false;
  }

  function $onDestroy() {
    if (vm.didStepChange === false) {
      updateCurrentAnswer();
    }
  }

  function updateCurrentAnswer() {
    return performanceReviewService.update
      .answer(vm.data.question.answer.id, vm.choice, vm.reflection, vm.what, vm.how, vm.when);
  }

  function stepChange(to) {
    return updateCurrentAnswer()
      .then(vm.stepChangeOk(to))
      .catch(vm.stepChangeFailed(to));
  }

  function stepChangeOk(to) {
    vm.didStepChange = true;
    return function okResponse(response) {
      $location.path($interpolate('/performance-review/questionnaire/{{token}}/{{step}}')({token: vm.data.token, step: to}));
      return response;
    };
  }

  function stepChangeFailed(to) {
    return function failedResponse(error) {
      var modal = $modal({template: require('./performance-review-questionnaire.modal.html'), show: true, locals: {to: to}});
      errorHandlerService.updateModalError(modal, error);
      return error;
    };
  }

  function hasBusinessGoals() {
    return vm.data.goals.length > 0;
  }

  function showBusinessGoals() {
    var modal = $modal({template: require('./performance-review-questionnaire.goals.modal.html'), show: true});
    modal.$scope.goals = replaceURLWithHTMLLinks(vm.data.goals);
  }

  function replaceURLWithHTMLLinks(text) {
    var exp = /(\b(https?|ftp|file):\/\/[-A-ZäöåÄÖÅ0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
    return text.replace(exp, '<a href="$1" target="_blank">$1</a>');
  }

  function hasRole(role) {
    return vm.me.groups
      .map(function (group) { return group.name; })
      .some(function (groupName) { return groupName === role; });
  }
}

module.exports = PerformanceReviewQuestionnaireController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/performance-review/performance-review-questionnaire/performance-review-questionnaire.controller.js
 ** module id = 273
 ** module chunks = 0
 **/